<template>
    <b-container fluid>
        <b-row>
            <b-col lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-overlay :show="loader">
                            <b-row>
                                <b-col xl="12" lg="12" sm="12">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(addTmp)" @reset.prevent="reset">
                                            <b-row class="mt-2">
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Organization" vid="organization_id" rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="organization_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.organization_name')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.org_id"
                                                                id="organization"
                                                                :options="orgList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Institute Type" vid="institute_type_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="institute_type"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.institute_type')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.office_type_id"
                                                                id="institute_type"
                                                                :options="officeTypeList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Institute Name" vid="institute_name" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="institute_name"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.institute_name')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.office_id"
                                                                id="institute_name"
                                                                :options="officeList"
                                                                @change="InstituteChange(formData.office_id)"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12"></b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Class" vid="class" rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="class"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.class')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.class_id"
                                                                id="class"
                                                                :options="classList"
                                                                @change="getStudentData(formData.class_id)"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <b-spinner v-if="studentSpinLoader && !id" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                                    <ValidationProvider name="Student ID" vid="student_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="student_id"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.student_id')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="formData.student_id"
                                                                id="student_id"
                                                                :options="applicantlist"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Distribution Date" vid='distribution_date' rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="distribution_date"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('ds_institute_management.distribution_date')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <flat-pickr class="form-control"
                                                                placeholder="Select Date"
                                                                v-model="formData.distribution_date"
                                                                id="distribution_date"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            </flat-pickr>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Receive Date" vid='recieve_date' rules="">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            :label="$t('ds_institute_management.recieve_date')"
                                                            label-for="recieve_date"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <flat-pickr class="form-control"
                                                                :disabled="formData.distribution_date ? false : true"
                                                                :config="{ minDate: formData.distribution_date }"
                                                                v-model="formData.receive_date"
                                                                id="recieve_date"
                                                                placeholder="Select Date"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            </flat-pickr>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Remarks (En)" vid='remarks_en' rules="">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="remarks_en"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('ds_config.remarks_en')}}
                                                            </template>
                                                            <b-form-textarea
                                                                id="remarks_en"
                                                                v-model="formData.remarks"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-textarea>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="6">
                                                    <ValidationProvider name="Remarks (Bn)" vid='remarks_bn' rules="">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="remarks_bn"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('ds_config.remarks_bn')}}
                                                            </template>
                                                            <b-form-textarea
                                                                id="remarks_bn"
                                                                v-model="formData.remarks_bn"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-textarea>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                            </b-row>
                                            <hr>
                                            <b-row class="mt-2">
                                                <b-col lg="6" sm="12">
                                                    <b-spinner v-if="spinLoader && !id" class="overlay" variant="success" small label="Spinning"></b-spinner>
                                                    <ValidationProvider name="Book Name" vid="book_name" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="book_name"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.book_name')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="detailsData.book_id"
                                                                id="book_name"
                                                                :options="booklist"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <div class="col text-left">
                                                        <b-button type="submit" title="Add More" variant="primary" class="mr-0"><i class="ri-add-line m-0"></i></b-button>
                                                    </div>
                                                </b-col>
                                            </b-row>
                                        </b-form>
                                    </ValidationObserver>
                                    <ValidationObserver ref="form1"  v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset">
                                            <br/>
                                            <b-row>
                                                <b-table-simple  bordered>
                                                    <thead>
                                                    <tr class="bg-primary">
                                                        <th style="width:10%" scope="col">{{ $t('globalTrans.sl_no') }}</th>
                                                        <th scope="col">{{ $t('ds_institute_management.book_name') }}</th>
                                                        <th scope="col" class="text-center">{{ $t('globalTrans.action') }}</th>
                                                    </tr>
                                                    </thead>
                                                    <b-tbody>
                                                        <b-tr v-for="(item, index) in formData.details" :key="index">
                                                            <b-td>
                                                                {{ $n(index + 1) }}
                                                            </b-td>
                                                            <b-td>
                                                                <ValidationProvider name="Course Name" vid="course_id" rules="required|min_value:1">
                                                                    <b-form-group
                                                                        class="mb-0"
                                                                        slot-scope="{ valid, errors }"
                                                                    >
                                                                        <b-form-select
                                                                            v-model="item.book_id"
                                                                            id="course_name"
                                                                            :options="booklist"
                                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                                        >
                                                                            <template v-slot:first>
                                                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                            </template>
                                                                        </b-form-select>
                                                                        <div class="invalid-feedback">
                                                                            {{ errors[0] }}
                                                                        </div>
                                                                    </b-form-group>
                                                                </ValidationProvider>
                                                            </b-td>
                                                            <b-td>
                                                                <b-button v-if="id !== 0 && item.is_received === 0" type="button" @click="deleteItem(index)" class="btn btn- iq-bg-danger btn-sm text-center ml-1"><i class="ri-delete-bin-line m-0"></i></b-button>
                                                                <b-button v-if="id === 0" type="button" @click="deleteItem(index)" class="btn btn- iq-bg-danger btn-sm text-center ml-1"><i class="ri-delete-bin-line m-0"></i></b-button>
                                                            </b-td>
                                                        </b-tr>
                                                    </b-tbody>
                                                </b-table-simple>
                                            </b-row>
                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col text-right">
                                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>                                                    &nbsp;
                                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
import { LibraryBookDistributionStoreApi, LibraryBookDistributionUpdateApi, LibraryBookDistributionBookListApi, LibraryBookDistributionStudentListApi } from '../../api/routes'
import flatpickr from 'flatpickr'

export default {
    name: 'FormLayout',
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
      created () {
        this.formData.org_id = this.$store.state.dataFilters.orgId
        this.formData.office_type_id = this.$store.state.dataFilters.officeTypeId
        this.formData.office_id = this.$store.state.dataFilters.officeId
        if (this.formData.office_id) {
            this.InstituteChange(this.formData.office_id)
        }
        if (this.id) {
            this.loader = true
            const tmp = this.getData()
            this.InstituteChange(tmp.office_id)
            this.formData = tmp
            this.formData.old_details = [...tmp.details]
            this.getStudentData(tmp.class_id)
            this.formData.edit_id = this.id
        }
    },
    mounted () {
        core.index()
        flatpickr('.date-picker', {})
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            loader: false,
            spinLoader: false,
            studentSpinLoader: false,
            formData: {
                org_id: 0,
                office_type_id: 0,
                office_id: 0,
                student_id: '',
                class_id: '',
                distribution_date: '',
                receive_date: '',
                remarks: '',
                remarks_bn: '',
                details: []
            },
            detailsData: {
                book_id: 0
            },
            officeTypeList: [],
            officeList: [],
            classlist: [],
            booklist: [],
            applicantlist: []
        }
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        },
        classList: function () {
            return this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        }
    },
    watch: {
        'formData.org_id': function (newVal) {
            this.officeTypeList = this.getOfficeTypeList(newVal)
        },
        'formData.office_type_id': function (newVal) {
            this.officeList = this.getOfficeList(newVal)
        }
    },
    methods: {
        async getStudentData (classId) {
            this.studentSpinLoader = true
            let result = null
            result = await RestApi.postData(disabilitySchoolServiceBaseUrl, LibraryBookDistributionStudentListApi, { office_id: this.formData.office_id, class_id: classId })
            if (result.success) {
                this.studentSpinLoader = false
                this.applicantlist = result.data
                this.applicantlist.map(element => {
                    element.value = element.id
                    element.text = this.$i18n.locale === 'en' ? element.name_en + ' (Roll-' + element.student_id + ')' : element.name_bn + ' (রোল-' + this.$n(element.student_id, { useGrouping: false }) + ')'
                })
            } else {
            }
        },
        async InstituteChange (officeId) {
            this.spinLoader = true
            let result = null
            result = await RestApi.postData(disabilitySchoolServiceBaseUrl, LibraryBookDistributionBookListApi, { office_id: officeId })
            if (result.success) {
                this.booklist = result.data.map(item => {
                    return Object.assign({ value: item.value, text: this.$i18n.locale === 'en' ? item.text_en : item.text_bn })
                })
                this.spinLoader = false
                this.loader = false
            } else {
            }
        },
        getOfficeTypeList () {
            const objectData = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.formData.org_id)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        getOfficeList () {
            const objectData = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.formData.office_type_id)
            return objectData.map((obj, key) => {
                if (this.$i18n.locale === 'bn') {
                    return { value: obj.value, text: obj.text_bn }
                } else {
                    return { value: obj.value, text: obj.text_en }
                }
            })
        },
        addTmp () {
            const bookId = this.detailsData.book_id
            const books = this.formData.details.find(item => item.book_id === bookId)
            if (typeof books === 'undefined') {
                this.formData.details.push(JSON.parse(JSON.stringify(this.detailsData)))
                this.detailsData.book_id = 0
                this.$nextTick(() => {
                    this.$refs.form.reset()
                })
            }
        },
        deleteItem (index) {
            this.formData.details.splice(index, 1)
        },
        async storeUpdate () {
            if (this.formData.details.length > 0) {
                this.loader = true
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                let result = null
                const loadinState = { loading: false, listReload: true }
                if (this.id) {
                    result = await RestApi.putData(disabilitySchoolServiceBaseUrl, `${LibraryBookDistributionUpdateApi}/${this.id}`, this.formData)
                } else {
                    result = await RestApi.postData(disabilitySchoolServiceBaseUrl, LibraryBookDistributionStoreApi, this.formData)
                }
                this.$store.dispatch('mutateCommonProperties', loadinState)
                if (result.success) {
                    this.loader = false
                    this.$store.dispatch('DisabilitySchoolService/mutateCommonObj', { hasDropdownLoaded: false })
                    this.$toast.success({
                        title: this.$t('globalTrans.success'),
                        message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-4')
                } else {
                    this.loader = false
                    this.$refs.form.setErrors(result.errors)
                }
            } else {
                this.$toast.error({
                    title: this.$i18n.locale === 'bn' ? 'অনুগ্রহপূর্বক, অন্তত একটি বই যোগ করুন' : 'Please, add at least one book!',
                    message: ' ',
                    color: '#D6E09B'
                })
            }
        },
        getData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        }
    }
}
</script>
<style scoped>
.overlay {
    position: absolute;
    left: 65%;
    z-index: 9999;
    top: 10px;
    text-align: center;
}
</style>
